export default __webpack_public_path__ + "static/media/bg-mobile.8343af15.webp";